import getLinkHref from '@/modules/utils/api/getLinkHref'
import clientHTTP from '@/modules/clientHTTP'
import constants from '@/configuration/constants'

const getApplication = () => {
  return clientHTTP.get(constants.gmsUrl + '/application')
}

const getCapabilities = (application, params = {}) => {
  return clientHTTP.get(getLinkHref(application, 'capabilities'), params)
}

const getWebServices = (application, params = {}) => {
  return clientHTTP.getAll(getLinkHref(application, 'webServices'), params)
}

const getDtos = (application, params = {}) => {
  return clientHTTP.getAll(getLinkHref(application, 'dtos'), params)
}

const getRemoteShellVersion = () => {
  return clientHTTP.get(constants.remoteShellUrl + '/version', {}, {}, { defaultErrorMessage: false, timeout: 10000 })
}

/**
* HOME, SETTINGS, ACTIONS, AND OTHER META PAGES
 */

const getStats = (application) => {
  return clientHTTP.get(getLinkHref(application, 'stats'))
}

const getCustomersSettings = (application, params = {}) => {
  return clientHTTP.get(getLinkHref(application, 'customersSettings'), params)
}

const createCustomersSettings = (application, params = {}) => {
  return clientHTTP.post(getLinkHref(application, 'customersSettings'), params)
}

const getActions = (application, params = {}) => {
  return clientHTTP.get(getLinkHref(application, 'actions'), params)
}

/**
* UTILS
 */

const getPasswordStrength = (application, password, authToken) => {
  const authHeader = authToken ? { Authorization: 'Bearer ' + authToken } : null
  return clientHTTP.get(getLinkHref(application, 'passwordStrength') + '?' + clientHTTP.encodeParams({ password }), null, authHeader)
}

export default {
  getApplication,
  getCapabilities,
  getWebServices,
  getDtos,
  getRemoteShellVersion,
  // HOME, SETTINGS, ACTIONS, AND OTHER META PAGES
  getStats,
  getCustomersSettings,
  createCustomersSettings,
  getActions,
  // UTILS
  getPasswordStrength
}
